import { IntlShape } from "react-intl";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IFaqResponse } from "../../Orchestrator/Types/Interface/INeedHelp";

export async function getFaqsList(
  intl: IntlShape
): Promise<IApiResponse<IFaqResponse>> {
  const ENDPOINTS = await getEndpoints();
  const params = new URLSearchParams({
    "populate[faqs][populate]": "*",
    "populate[faqs][sort][0]": "createdAt:asc",
    sort: "createdAt:asc",
    locale: intl.locale,
  });
  const endpoint = `${ENDPOINTS.getFaqsList}?${params.toString()}`;
  return await cmsApiRequest<IFaqResponse>(endpoint, "GET");
}


export async function getCorporateAccountFaqsList(
  intl: IntlShape
): Promise<IApiResponse<IFaqResponse>> {
  const ENDPOINTS = await getEndpoints();
  const params = [
    'filters[slug][%24eq]=request-corporate-account',
    'populate[faqs][populate]=*',
    `locale=${intl.locale}`
  ].join('&');
  const endpoint = `${ENDPOINTS.getFaqsList}?${params.toString()}`;
  return await cmsApiRequest<IFaqResponse>(endpoint, "GET");
}
